export const path = (...paths: string[]) => `/${paths.join("/")}`
